import React from "react";
import DataTable from "react-data-table-component";
import { getFormattedPrice } from "../../../services/helper";

const TransactionTable = ({ data, onView, onDelete }) => {
  const columns = [
    {
      name: "ID",
      selector: (row) => row.order_id,
      sortable: true,
      width: "18%",
    },
    {
      name: "Total Amount",
      selector: (row) => row.order_total,
      sortable: true,
      width: "15%",
    },
    {
      name: "Discount",
      selector: (row) => row.discount || 0,
      cell: (row) => (
        <span style={{ color: row.discount > 0 ? "green" : "inherit" }}>
          {row.discount > 0 ? getFormattedPrice(row.discount) : "-"}
        </span>
      ),
      sortable: true,
      width: "12%",
    },
    {
      name: "Tax",
      selector: (row) => row.tax_collected || 0,
      cell: (row) => (
        <span>
          {row.tax_collected > 0 ? getFormattedPrice(row.tax_collected) : "-"}
        </span>
      ),
      sortable: true,
      width: "12%",
    },
    {
      name: "Paid",
      selector: (row) => row.amount_paid,
      sortable: true,
      width: "15%",
    },
    {
      name: "Due/Balance",
      cell: (row) => {
        const due = parseFloat(row.order_total) - parseFloat(row.amount_paid);
        return due > 0 ? `$${due.toFixed(2)}` : '$0.00';
      },
      sortable: true,
      width: "15%",
    },
    {
      name: "Payment Types",
      cell: (row) => {
        if (row.split_payment?.payments) {
          return row.split_payment.payments
            .map(p => `${p.type}: ${getFormattedPrice(p.amount)}`)
            .join(", ");
        }
        return row.payment_type || "N/A";
      },
      width: "20%",
    },
    {
      name: "Refund",
      selector: (row) => row.refund_amount || 0,
      cell: (row) => (
        <span style={{ color: row.refund_amount > 0 ? "red" : "inherit" }}>
          {row.refund_amount > 0 ? getFormattedPrice(row.refund_amount) : "-"}
        </span>
      ),
      sortable: true,
      width: "16%",
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      striped
      highlightOnHover
      onRowClicked={onView}
      pointerOnHover
    />
  );
};

export default TransactionTable;